<div class="sidebar__header">
  <button
    class="toggle-button"
    type="button"
    puButton
    uiType="quinary"
    (click)="toggle()"
  >
    <mat-icon [svgIcon]="isCollapsed() ? 'menu-close' : 'menu-open'"/>
  </button>

  <ca-bots-logo />
</div>

<div class="bot-selector-wrapper">
  <ca-bot-selector
    (puControlValueChanges)="botChanged($event)"
    [isCollapsed]="isCollapsed()"
    [bots]="(bots$ | async) || []"
    [isLoading]="isBotsLoading$ | async"
    [formControl]="botControl"
  />
</div>

<div class="sidebar__menu">
  <ca-menu-item
    *ngxPermissionsOnly="'UsersPage'"
    [isDisabled]="!isBotSelected()"
    [isCollapsed]="isCollapsed()"
    link="/{{ currentLicense }}/bot/{{ botControl.value }}/users"
    icon="users"
    [label]="'sidebar.nav.users' | translate"
  />

  <ca-menu-item
    *ngxPermissionsOnly="['FlowEditorPage']"
    [isDisabled]="!isBotSelected()"
    [isCollapsed]="isCollapsed()"
    icon="list-square"
    [label]="'sidebar.nav.content' | translate"
  >
    <ca-menu-item
      [isDisabled]="!isBotSelected()"
      [isCollapsed]="isCollapsed()"
      link="/{{ currentLicense }}/bot/{{ botControl.value }}/triggers"
      [label]="'sidebar.nav.triggers' | translate"
    />

    <ca-menu-item
      [isDisabled]="!isBotSelected()"
      [isCollapsed]="isCollapsed()"
      link="/{{ currentLicense }}/bot/{{ botControl.value }}/flows"
      [label]="'sidebar.nav.flows' | translate"
    />
  </ca-menu-item>

  <ca-menu-item
    *ngxPermissionsOnly="['CampaignsPage']"
    [isDisabled]="!isBotSelected()"
    [isCollapsed]="isCollapsed()"
    link="/{{ currentLicense }}/bot/{{ botControl.value }}/campaigns"
    icon="bell"
    [label]="'sidebar.nav.campaigns' | translate"
  />

  <ca-menu-item
    *ngxPermissionsOnly="['AnalyticsPage']"
    [isDisabled]="!isBotSelected()"
    [isCollapsed]="isCollapsed()"
    link="/{{ currentLicense }}/bot/{{ botControl.value }}/analytics"
    icon="monitorings"
    [label]="'sidebar.nav.analytics' | translate"
  />

  <ca-menu-item
    *ngxPermissionsOnly="['FeedbacksPage']"
    [isDisabled]="!isBotSelected()"
    [isCollapsed]="isCollapsed()"
    link="/{{ currentLicense }}/bot/{{ botControl.value }}/feedbacks"
    icon="message-square"
    [label]="'sidebar.nav.feedback' | translate"
  />

  <ca-menu-item
    *ngxPermissionsOnly="['BotSettingsPage']"
    [isDisabled]="!isBotSelected()"
    [isCollapsed]="isCollapsed()"
    icon="settings-wheel"
    [label]="'sidebar.nav.settings' | translate"
  >
    <ca-menu-item
      [isDisabled]="!isBotSelected()"
      [isCollapsed]="isCollapsed()"
      link="/{{ currentLicense }}/bot/{{ botControl.value }}/settings/general"
      [label]="'sidebar.nav.settings.general' | translate"
    />

    <ca-menu-item
      [isDisabled]="!isBotSelected()"
      [isCollapsed]="isCollapsed()"
      link="/{{ currentLicense }}/bot/{{ botControl.value }}/settings/stickers"
      [label]="'sidebar.nav.settings.stickers' | translate"
    />
  </ca-menu-item>
</div>

<div class="sidebar__profile">
  @if (profile$ | async; as profile) {
    <ca-profile-card
      [isCollapsed]="isCollapsed()"
      [user]="profile"
    />
  }
</div>
